module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBoldItalic.2d3cef9.ttf";